import React, { FC } from 'react';
import { ImproveSiteFormProps } from './ImproveSiteFormProps';
import LocationInfoFields from '../LocationInfoFields';
import SiteInfoFields from '../SiteInfoFields';

const ImproveSiteForm: FC<ImproveSiteFormProps> = ({
  countries,
  BUList,
  onCountryChange,
  onBUChange,
  isep,
  transactionType,
  isLeasedFromAnotherIngkaCompany,
  currencyRate,
  currency,
  isEdit,
}) => {
  return (
    <>
      <LocationInfoFields
        countries={countries}
        buCode
        locationName
        onBUChange={onBUChange}
        onCountryChange={onCountryChange}
        BUList={BUList}
        buCodeRequired
        isep={isep}
        isEdit={isEdit}
      />
      <SiteInfoFields
        transactionType={transactionType}
        isLeasedFromAnotherIngkaCompany={isLeasedFromAnotherIngkaCompany}
        unit
        unitCategoryDisabled
        unitType
        site
        lease
        currencyRate={currencyRate}
        currency={currency}
      />
    </>
  );
};

export default ImproveSiteForm;
